import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { GenericModal } from "@Shared/components/modals";
import { computed, ref, toRefs } from "@vue/composition-api";
import * as BoardActions from "@Broker/@Modules/clients/board/store/board-actions";
import * as BoardGetters from "@Broker/@Modules/clients/board/store/board-getters";
import { useBoardStoreActions, useBoardStoreGetters } from "@Broker/@Modules/clients/board/store/board-helpers";
import { useI18n } from "vue-i18n-composable";
import { showToast } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfileMasterUnsubscribeConfirmation",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      default: ""
    },
    unsubscribeAuthor: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const masterUnsubscribeModal = ref(null);
    const {
      clientProfileId,
      unsubscribeAuthor
    } = toRefs(props);
    const {
      CHANGE_CLIENT_PROFILE_MASTER_SUBSCRIPTION
    } = useBoardStoreActions([BoardActions.CHANGE_CLIENT_PROFILE_MASTER_SUBSCRIPTION]);
    const {
      GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED
    } = useBoardStoreGetters([BoardGetters.GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED]);
    const currentProfileMasterUnsubscribed = computed(() => GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED.value(clientProfileId.value));
    const masterUnsubscribeDoneByClient = computed(() => unsubscribeAuthor.value === "client");
    const handleMasterUnsubscribe = async () => {
      loading.value = true;
      const {
        succeeded
      } = await CHANGE_CLIENT_PROFILE_MASTER_SUBSCRIPTION({
        clientProfileId: clientProfileId.value,
        unsubscribe: !currentProfileMasterUnsubscribed.value
      });
      if (succeeded) {
        const toastText = currentProfileMasterUnsubscribed.value ? "masterUnsubscribed" : "masterSubscribed";
        showToast("success", toastText);
        masterUnsubscribeModal.value.hide();
      }
      loading.value = false;
    };
    const subscribeText = computed(() => currentProfileMasterUnsubscribed.value ? t("client-profile.actions.masterSubscribe") : t("client-profile.actions.masterUnsubscribe"));
    const confirmText = computed(() => currentProfileMasterUnsubscribed.value ? t("client-profile.actions.masterSubscribeConfirmation") : t("client-profile.actions.masterUnsubscribeConfirmation"));
    const confirmTextBody = computed(() => currentProfileMasterUnsubscribed.value ? t("client-profile.actions.masterSubscribeConfirmationText") : t("client-profile.actions.masterUnsubscribeConfirmationText"));
    return {
      loading,
      handleMasterUnsubscribe,
      subscribeText,
      confirmText,
      confirmTextBody,
      currentProfileMasterUnsubscribed,
      masterUnsubscribeDoneByClient,
      masterUnsubscribeModal
    };
  }
});